import {useEffect,useState} from 'react';
import {api} from '../api';

type Day={day:string;automatic:number;byPerson:number;corrected:number};
type Rate={days:Day[];rate:number|null;waiting:number};
const sum=(days:Day[],key:'automatic'|'byPerson'|'corrected')=>days.reduce((total,day)=>total+day[key],0);

/** Priority 3 (20 Oct 2026): how much filing happened without a person over the last 30 days, from the filing records. */
export function DocumentAutomationRate(){
 const [rate,setRate]=useState<Rate|null>();
 useEffect(()=>{let active=true;void api<Rate>('/api/documents/automation-rate?days=30').then(next=>{if(active)setRate(next)}).catch(()=>{if(active)setRate(null)});return()=>{active=false;};},[]);
 if(rate===null)return <p>The automation rate could not be loaded.</p>;
 if(!rate)return null;
 const automatic=sum(rate.days,'automatic'),byPerson=sum(rate.days,'byPerson'),corrected=sum(rate.days,'corrected');
 return <section className="panel" aria-labelledby="automation-rate-heading"><h2 id="automation-rate-heading">Filing automation, last 30 days</h2>
  <div className="metric-grid">
   <div className="metric"><span>Filed automatically</span><strong>{rate.rate===null?'None filed':`${rate.rate}%`}</strong><small>{automatic} of {automatic+byPerson} filed</small></div>
   <div className="metric"><span>Filed by a person</span><strong>{byPerson}</strong></div>
   <div className="metric"><span>Corrected after filing</span><strong>{corrected}</strong></div>
   <div className="metric"><span>In the review queue now</span><strong>{rate.waiting}</strong></div>
  </div>
 </section>;
}
